import { render, staticRenderFns } from "./NoPage.vue?vue&type=template&id=025c550f&"
import script from "./NoPage.vue?vue&type=script&lang=js&"
export * from "./NoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports